"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asNullable = void 0;
const sanitizers_1 = require("@restless/sanitizers");
const asNullable = (sanitizer) => (0, sanitizers_1.asAnyOf)([sanitizer, (0, sanitizers_1.asExactly)(null)], 'nullable value');
exports.asNullable = asNullable;
//# sourceMappingURL=asNullable.js.map